// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"557":"article-page","594":"about","757":"not-found","962":"home"}[chunkId] || chunkId) + "." + {"131":"739e98d7","557":"c2d26149","594":"c69d99db","614":"ae0f063c","686":"82c7d1f2","757":"b6ba684c","962":"77c89b78"}[chunkId] + ".js";
};